import React, { PropsWithChildren } from 'react';
import { GestureHandlerRootView } from 'react-native-gesture-handler';

import { appTheme } from '@/components/lib/theme';
import { queryClient } from '@/data';
import { common } from '@/styles/styles';
import { ThemeProvider } from '@shopify/restyle';
import { QueryClientProvider } from '@tanstack/react-query';

export * from './FantasyUrqlClientProvider';
export * from './BonusEngineClientProvider';
export * from './TradingCardsClientProvider';

export const ReactQueryClientProvider = ({ children }: PropsWithChildren) => {
    return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
};

export const GestureHandlerRootViewProvider = ({ children }: PropsWithChildren) => {
    return <GestureHandlerRootView style={common.flex}>{children}</GestureHandlerRootView>;
};

export const BetrThemeProvider = ({ children }: PropsWithChildren) => {
    return <ThemeProvider theme={appTheme}>{children}</ThemeProvider>;
};
